import {getTheme, ITheme, Panel, PanelType} from '@fluentui/react';
import React from 'react';
import {withTranslation, WithTranslation} from 'react-i18next';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import SplitPane, {Pane} from 'react-split-pane';
import history from '../../history';
import {messageService} from '../../services/messageService';
import ConfirmationDialog from '../../shared/confirmationDialog/confirmationDialog';
import {getContractingUnit, getProject} from '../../shared/util';
import {BookMarkItem} from '../../types/template';
import '../style/style.css';
import CommandBarLeft from './commandBar/commandBarLeft';
import CommandBarRight from './commandBar/commandBarRight';
import DocumentPane from './documentPane/container';
import DocumentPaneSection from '../../shared/mainUI/documentPaneSection/documentPaneSection';
import withMainUI from '../../shared/mainUI/withMainUI';
import ListPane from './listPane/container';
import ListPaneSection from '../../shared/mainUI/listPaneSection/component';
import ShortCutPane from './../stock/shortCutPane/container';
import {
  clearFormData,
  filterWarehouseListPaneData,
  readByWarehouseId,
  readWarehouseDropDownData,
  readWarehouseShortCutPaneData,
} from '../../reducers/warehouseReducer';
import {
  SHORTCUTPANE_ALL,
  SHORTCUTPANE_WAREHOUSE_ID,
  Warehouse,
  warehouseFormData,
  WarehouseListPaneFilter,
  WarehouseListPaneItem,
} from '../../types/warehouse';
import {StockShortCutPaneMain, StockShotcutPaneFilter} from '../../types/stock';
import {resizerStyle} from '../../shared/customStyle/commonStyles';


export interface State {
  selectedShortCutItem: StockShotcutPaneFilter;
  filter: WarehouseListPaneFilter;
  formData: Warehouse;
  loading: boolean;
  showPanel: boolean;
  width: number;
  activeClass: string;
  bookmarkDivClass: string;
  showDetails: boolean;
  autoSave: boolean;
  isEdit: boolean;
  isDisableNewButton: boolean;
  isDrag: boolean;
  resetLayout: boolean;
  collapseBookmarkPane: boolean;
  reSizer: number;
  projectId: null | string;
  purchaseOrderType: null | string;
  isNewWarehouse: boolean;
}

interface Props extends WithTranslation {
  match: any;
  resetFormData: () => void;
  showProgressBar: boolean;
  shortCutPaneFilters: StockShotcutPaneFilter;
  formData: Warehouse;
  setUid: () => void;
  clearUid: () => void;
  resetIsChange: () => void;
  uid: string | null;
  autoSave: boolean;
  isChange: boolean;
  isEdit: boolean;
  isDataLoaded?: boolean;
  loadMsg: string;
  location: any;
  loading: boolean;
  handleShowDocumentPane: (collapseBookmarkPane?: boolean) => void;
  reSizer: number;
  collapseBookmarkPane: boolean;
  showDetails: boolean;
  showPanel: boolean;
  handleScroll: () => void;
  currentActiveSection: string;
  animation: any;
  readWarehouseShortCutPaneData: () => void;
  filterWarehouseListPaneData: (filter: WarehouseListPaneFilter) => void;
  readWarehouseDropDownData: () => void;
  readByWarehouseId: (id: string) => void;
  clearFormData: () => void;
  shortcutPaneData: StockShortCutPaneMain;

  listPaneItems: WarehouseListPaneItem[];
  isWarehouseListLoaded: boolean;
  warehouseDropDowns: any;
  isLoading: boolean;
}

class WarehouseMainLayout extends React.Component<Props, State> {
  _isMounted = false;
  theme: ITheme = getTheme();
  subscription: any;

  bookmarkList: BookMarkItem[] = [
    {
      id: 1,
      link: 'warehouse-header',
      label: this.props.t('warehouseHeader'),
    },
    {
      id: 2,
      link: 'history',
      label: this.props.t('history'),
    },
  ];


  constructor(props: Props) {
    super(props);
    this.state = {
      filter: new WarehouseListPaneFilter(),
      selectedShortCutItem: {
        id: null,
        name: null,
        sorter: { attribute: null, order: null },
        status: null,
        title: null,
        type: null,
        wharehouseTaxonomy: null,
        wareHouse: null,
        typeId: null,
        resourceType: null,
      },
      isEdit: false,
      autoSave: false,
      loading: false,
      width: window.innerWidth,
      showPanel: false,
      activeClass: 'grid-righter column-filter-activated',
      bookmarkDivClass: 'bookmark-panel parent',
      showDetails: false,
      formData: warehouseFormData,
      isDisableNewButton: false,
      isDrag: false,
      resetLayout: false,
      collapseBookmarkPane: false,
      reSizer: screen.width,
      projectId: null,
      purchaseOrderType: null,
      isNewWarehouse: false,
    };
  }

  componentDidMount() {
    this.handleUrlChange();
    this.props.readWarehouseDropDownData();
    this.props.readWarehouseShortCutPaneData();
    this.props.filterWarehouseListPaneData(new WarehouseListPaneFilter());

    if (
      location.pathname.split('/').pop() === 'new' &&
      this.state.formData &&
      this.state.formData.id === null
    ) {
      this.createNew();
    }
    this.setState(
      {
        formData: this.props.formData,
      },
      this.props.handleShowDocumentPane,
    );
    this.subscription = messageService.getMessage().subscribe((data: any) => {
      if (data) {
        if (data.data.hideDocumentPane) {
          this.hideDocumentPane();
        }

        if (data.data.isNewWarehouse) {
          this.createNew();
        }
        if (data.data.purchaseOrderType) {
          this.setState({ purchaseOrderType: data.data.purchaseOrderType });
        }

        if (
          data &&
          data.data &&
          data.data.hasOwnProperty('isLoadingPMOLData') &&
          data.data.isLoadingPMOLData
        ) {
          this.setState({ isDisableNewButton: true });
        } else if (
          data.data.hasOwnProperty('isLoadingPMOLData') &&
          !data.data.isLoadingPMOLData
        ) {
          this.setState({ isDisableNewButton: false });
        }
      }
    });
  }

  componentDidUpdate(prevProps: Props, prevState: State) {
    if (this.props.isChange !== prevProps.isChange && this.props.isChange) {
      this.reloadListPaneItem();
    }
    if (this.props.match.url !== prevProps.match.url) {
      this.handleUrlChange(prevState.collapseBookmarkPane);
    }
    if (this.props.collapseBookmarkPane !== prevProps.collapseBookmarkPane) {
      this.setState({
        collapseBookmarkPane: this.props.collapseBookmarkPane,
      });
    }
    if (this.props.formData !== prevProps.formData) {
      this.setState({
        formData: this.props.formData,
      });
    }
    if (this.props.isEdit !== prevProps.isEdit) {
      this.setState({
        isEdit: this.props.isEdit,
      });
    }
    if (
      this.props.location &&
      this.props.location.state &&
      this.props.location.state?.stockSCFilter &&
      prevProps.location.state?.stockSCFilter != this.props.location.state?.stockSCFilter
    ) {
      if (this.props.location.state?.stockSCFilter) {
        messageService.sendMessage({ selectedShortCutPaneItem: this.props.location.state?.stockSCFilter.id });
        if (this.props.location.state?.stockSCFilter.id === SHORTCUTPANE_WAREHOUSE_ID || this.props.location.state?.stockSCFilter.id === SHORTCUTPANE_ALL) {
          this.setState(
            {
              filter: new WarehouseListPaneFilter(),
              selectedShortCutItem: this.props.location.state?.stockSCFilter,
            },
            this.reloadListPaneItem,
          );
        } else {
          this.setState(
            {
              filter: { ...this.state.filter, type: this.props.location.state?.stockSCFilter.id },
              selectedShortCutItem: this.props.location.state?.stockSCFilter,
            },
            this.reloadListPaneItem,
          );
        }
      }
    }
  }

  handleUrlChange(collapseBookmarkPane?: boolean) {
    let id = this.props.match.params.featureId ? this.props.match.params.featureId : null;
    let isNew = location.pathname.split('/').pop() === 'new';
    if (id && id != 'new') {
      this.setState(
        {
          isEdit: !!this.props.match.params.featureId,
          isDisableNewButton: id ? true : false,
          isDrag: false,
          resetLayout: collapseBookmarkPane ? false : true,
          collapseBookmarkPane: collapseBookmarkPane ? true : false,
        }, () => {
          this.props.handleShowDocumentPane(collapseBookmarkPane);
        });
      this.props.readByWarehouseId(id);
    } else {
      this.setState(
        {
          isEdit: false,
          isDisableNewButton: false,
          isDrag: false,
          resetLayout: true,
          collapseBookmarkPane: false,
          reSizer: isNew ? screen.width / 2 : screen.width,
        }, () => {
          this.props.handleShowDocumentPane();
        });
    }


  }

  componentWillUnmount() {
    this.subscription.unsubscribe();
  }

  // 2. clear states in this method and save to state
  // 3. update redirect url
  createNew = (): void => {
    this.props.clearFormData();
    //this.props.setUid();
    let formData: any = { ...warehouseFormData, id: this.props.uid };
    this.setState({
      formData: formData,
      isNewWarehouse: true,
      purchaseOrderType: null,
    });
    if (getContractingUnit() && !getProject()) {
      history.push(`/CU/${getContractingUnit()}/stock-warehouse/new`);
    } else {
      history.push(`/CU/${getContractingUnit()}/project/${getProject()}/stock-warehouse/new`);
    }
  };

  reloadListPaneItem = () => {
    //this.props.resetIsChange();
    this.props.filterWarehouseListPaneData(this.state.filter);
  };


  renderShortCutPane = () => {
    return (
      <ShortCutPane
        projectId={this.state.projectId}
        shortCutPaneFilters={this.props.shortcutPaneData}
        filter={this.state.filter}
        handelShortCutPaneFilter={(selectedItem: any) =>
          this.handelShortCutPaneFilter(selectedItem)
        }
        toggleOverlay={this.state.collapseBookmarkPane}
        resetLayout={this.state.resetLayout}
        isExpand={this.state.collapseBookmarkPane}
      />
    );
  };

  getDocumentPaneView = () => {
    return (
      <DocumentPaneSection
        collapseBookmarkPane={this.state.collapseBookmarkPane}
        showProgress={this.props.showProgressBar}
        handleScroll={this.props.handleScroll}
        isEdit={this.state.isEdit}
        formData={this.props.formData}
        bookmarkList={this.bookmarkList}
        currentActiveSection={this.props.currentActiveSection}
        renderCommandBar={() => <CommandBarRight formData={this.props.formData}/>}

      >
        <DocumentPane
          formData={this.props.formData}
          isExpand={this.state.collapseBookmarkPane}
          isLoading={this.props.isLoading}
          isNewWarehouse={this.state.isNewWarehouse}
        />
      </DocumentPaneSection>
    );
  };

  private getListPaneView = () => {
    return (
      <ListPaneSection
        activeClass={this.state.activeClass}
        titlePaneHeader={
          (this.state.selectedShortCutItem && this.state.selectedShortCutItem.name)
            ? this.state.selectedShortCutItem.name!!
            : this.props.t('warehouse')
        }
        showProgress={this.props.showProgressBar}
        renderCommandBar={() => <CommandBarLeft disable={true}/>}
        renderShotcutPane={() => this.renderShortCutPane()}
      >
        <ListPane
          projectId={this.state.projectId}
          loadMsg={this.props.loadMsg}
          reloadListPaneItem={() => {
            this.reloadListPaneItem();
          }}
          filter={this.state.filter}
          listPaneItems={this.props.listPaneItems}
          isDataLoaded={this.props.isWarehouseListLoaded}
          isChange={this.props.isChange}
          formData={this.state.formData}
          handelFilter={(filter: WarehouseListPaneFilter) =>
            this.handleFilter(filter)
          }
          handleSelectedListPaneItem={(
            selectedListItemIds: [] | string[],
          ) => {
            //this.handleSelectedListPaneItem(selectedListItemIds);
          }}
          reSizer={this.props.reSizer}
        />
      </ListPaneSection>
    );
  };

  handleFilter = (filter: WarehouseListPaneFilter) => {
    if ((filter.title && filter.title.length >= 3) || filter.title === null) {
      this.setState({
        filter: filter,
      }, this.reloadListPaneItem);
    } else {
      this.setState({
        filter: filter,
      });
    }
  };

  handelShortCutPaneFilter = (selectedItem: any) => {
    this.setState({
      selectedShortCutItem: selectedItem,
    });
  };

  render() {
    const { t } = this.props;
    return (
      <div>
        <div className={'ms-Grid'}>
          <SplitPane
            className={'SplitPane'}
            split="vertical"
            minSize={300}
            maxSize={screen.width / 2}
            defaultSize={
              this.props.showDetails ? screen.width / 2 : screen.width
            }
            resizerStyle={resizerStyle}
            style={{ height: 'calc(100vh - 129px)' }}
            size={this.props.reSizer}
            onDragStarted={() => {
              this.setState({
                // isDrag:true,
                // collapseBookmarkPane:true,
                // resetLayout:false,
              });
            }}
            onResizerDoubleClick={() => {
              this.setState({
                reSizer: this.props.reSizer === 300 ? screen.width / 2 : 300,
                isDrag: !this.state.isDrag,
                collapseBookmarkPane: !this.state.collapseBookmarkPane,
                resetLayout: !this.state.resetLayout,
              });
            }}
            onDragFinished={(newSize: number) => {
              this.setState({
                // isDrag:false,
                // resetLayout:false,
                reSizer: newSize,
                collapseBookmarkPane: newSize < screen.width / 2,
              });
            }}
            onChange={(newSize: number) => {
              if (newSize === screen.width / 2) {
                this.setState({
                  resetLayout: true,
                  collapseBookmarkPane: false,
                });
              }
            }}
          >
            <Pane className={'SplitPane'}>{this.getListPaneView()}</Pane>
            <Pane className={'SplitPane'}>
              {this.props.showDetails && (
                <div
                  className={`${this.props.animation(this.props.showDetails)}`}
                  style={{
                    display: this.props.showDetails ? 'block' : 'none',
                    transition: 'all 0.9s linear',
                  }}
                >
                  {!this.props.showPanel && (
                    <div>{this.getDocumentPaneView()}</div>
                  )}
                </div>
              )}
            </Pane>
          </SplitPane>
        </div>
        <Panel
          isOpen={this.props.showPanel}
          type={PanelType.smallFixedFar}
          onDismiss={this._hidePanel}
          isLightDismiss={true}
          headerText={t('corporateProductCatalogue')}
          className="custom-detail-panel"
          closeButtonAriaLabel={t('close')}
        >
          {this.getDocumentPaneView()}
        </Panel>

        <ConfirmationDialog
          hidden={true}
          title={t('areyousure')}
          subText={t('youwonTbeabletorevertthis')}
          onClickConfirmDialog={() => {
          }}
          onClickCancelDialog={() => {
          }}
          cancelButtonText={t('noIwonT')}
          confirmButtonText={t('yesDeleteit')}
        />
      </div>
    );
  }

  private _hidePanel = () => {
    this.setState({ showPanel: false, showDetails: false });
    if (getContractingUnit() && !getProject()) {
      history.push(`/CU/${getContractingUnit()}/stock-warehouse`);
    } else {
      history.push(`/CU/${getContractingUnit()}/project/${getProject()}/stock-warehouse`);
    }
  };

  private hideDocumentPane = () => {
    if (getContractingUnit() && !getProject()) {
      history.push(`/CU/${getContractingUnit()}/stock-warehouse`);
    } else {
      history.push(`/CU/${getContractingUnit()}/project/${getProject()}/stock-warehouse`);
    }
  };
}

const mapStateToProps = (state: any, ownProps: any) => {
  return {
    shortcutPaneData: state.warehouse.warehouseShortCutdata,
    isWarehouseListLoaded: state.warehouse.isWarehouseListLoaded,
    listPaneItems: state.warehouse.listPaneItems,
    warehouseDropDowns: state.warehouse.warehouseDropDowns,
    isChange: state.warehouse.isChange,
    formData: state.warehouse.formData,
    showProgressBar: state.warehouse.showProgressBar,
    isEdit: state.warehouse.isEdit,
    isLoading: state.warehouse.isLoading,

  };
};

const mapDispatchToProps = {
  readWarehouseShortCutPaneData,
  filterWarehouseListPaneData,
  readWarehouseDropDownData,
  readByWarehouseId,
  clearFormData,
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withTranslation()(withMainUI(WarehouseMainLayout))),
);
